import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import type { ThumbProperties } from './Thumb.types';

const THUMB_UNCHECKED = 16;
const THUMB_CHECKED = 24;
const TRACK_PADDING = 4;

export const Thumb = styled(Box, {
  shouldForwardProp: property =>
    !['isChecked', 'isDisabled', 'dataTest'].includes(property as string),
})<ThumbProperties>(({ theme, isChecked, isDisabled }) => {
  const isDark = theme.palette.mode === 'dark';

  return {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
    transition: theme.transitions.create(
      ['width', 'height', 'left', 'right', 'background-color'],
      {
        duration: 250,
        easing: theme.transitions.easing.easeInOut,
      },
    ),
    ...(isChecked
      ? {
          width: THUMB_CHECKED,
          height: THUMB_CHECKED,
          right: TRACK_PADDING,
          left: 'auto',
          backgroundColor: isDisabled
            ? isDark
              ? theme.palette.grey[800]
              : theme.palette.grey[100]
            : isDark
              ? theme.palette.primary.dark
              : theme.palette.primary.contrastText,
        }
      : {
          width: THUMB_UNCHECKED,
          height: THUMB_UNCHECKED,
          left: TRACK_PADDING + 2,
          right: 'auto',
          backgroundColor: isDisabled
            ? isDark
              ? theme.palette.grey[600]
              : theme.palette.grey[400]
            : isDark
              ? theme.palette.grey[400]
              : theme.palette.grey[600],
        }),
  };
});
